const primaryPack = {
    '50': '#e2f8fa',
    '100': '#b7edf2',
    '200': '#88e2e9',
    '300': '#58d6e0',
    '400': '#34cdda',
    '500': '#10c4d3',
    '600': '#0ebece',
    '700': '#0cb6c8',
    '800': '#09afc2',
    '900': '#05a2b7',
    'A100': '#e1fbff',
    'A200': '#aef4ff',
    'A400': '#7bedff',
    'A700': '#62e9ff',
};
const accentPack = {
    '50': '#e2f0fc',
    '100': '#b6d9f7',
    '200': '#86c0f1',
    '300': '#55a6eb',
    '400': '#3093e7',
    '500': '#0c80e3',
    '600': '#0a78e0',
    '700': '#086ddc',
    '800': '#0663d8',
    '900': '#0350d0',
    'A100': '#f8faff',
    'A200': '#c5d7ff',
    'A400': '#92b5ff',
    'A700': '#79a3ff',

};
const primary = '#10c4d3';
const accent = '#0c80e3';
const backgroundColor = "#FFFFFF";
const blueColor = "#ca7f4";
const warn = "#FF0000";
const textLight='#808080';
const backdropColor='#41D6C3';
const lightBlack = '#1e1e1e';

export {
    primaryPack,
    accentPack,
    primary,
    accent,
    backgroundColor,
    blueColor,
    warn,
    textLight,
    backdropColor,
    lightBlack
}
